import React from 'react'

import { useField } from 'formik'
import { TextAreaFieldProps, WithTextAreaFieldProps } from './interface'

export function withTextAreaField(Component: React.FC<TextAreaFieldProps>) {
  function WithTextAreaField({
    className,
    textAreaClassName,
    name,
    label,
    placeholder,
    leftIcon,
    maxLength,
    showLength,
    showErrorMsg,
  }: WithTextAreaFieldProps) {
    const [field, { error, touched }, { setValue }] = useField(name)

    function handleChange(value: string) {
      setValue(value)
    }

    const compoenntProps = {
      ...field,
      className,
      textAreaClassName,
      label,
      placeholder,
      leftIcon,
      maxLength,
      error,
      touched,
      showLength,
      showErrorMsg,
      onChange: handleChange,
    }

    return <Component {...compoenntProps} />
  }

  return WithTextAreaField
}
